import { ResponseTranslation, Translation } from './Translations';

export interface SiteProperty {
  siteId: string;
  itemLocalName?: Translation;
  inventoryTypeReference?: string;
  itemCategoryCode?: string;
  itemLowestSubCategoryCode?: string;
}

export interface NumberedDocumentKey {
  reference: string | null;
  number: string | null;
}

export interface ItemMaster {
  id: string;
  itemCode: string;
  itemDisplayName: ResponseTranslation;
  // inventoryTypeReference / itemCategoryCode / itemLowestSubCategoryCode are projected
  // server-side from siteProperties[activeSite] at read time; on write, send them inside
  // siteProperties entries instead of at top level.
  inventoryTypeReference?: string;
  itemLongDisplayName: ResponseTranslation;
  itemDescription: ResponseTranslation;
  unitOfMeasure: number;
  itemCategoryCode?: string;
  itemLowestSubCategoryCode?: string;
  itemClassificationCode: string;
  certificationReferences?: string[];
  relationships?: ItemRelationship[];
  status: number;
  sgiCode: number;
  cisCode: number;
  baseYarnCode?: string;
  baseFabricCode?: string;
  baseGreigeCode?: string;
  baseProductRecipeNumber?: string;
  fieldToDisplay?: string;
  procurementItemCategoryReference?: string;
  glAccounts?: NumberedDocumentKey[];
  siteIds?: string[];
  siteProperties?: SiteProperty[];
}

export interface ItemCategory {
  id: string;
  code: string;
  mongoDBCollection?: string;
  displayName: ResponseTranslation;
  name: ResponseTranslation;
  parentCode: string;
  level: number;
  selectable: boolean;
  isActive: boolean;
  description?: string;
}

export interface ItemMasterCodeBatchCommand {
  itemCodes: string[];
}

export interface ItemMasterFilter {
  itemCategoryReference?: string;
  itemCategoryCode?: string;
  itemLowestSubCategoryCode?: string;
  itemCode?: string;
  inventoryTypeReference?: string;
  description?: string;
  name?: string;
  baseYarnCode?: string;
  baseGreigeCode?: string;
  baseFabricCode?: string;
  baseProductRecipeNumber?: string;
}

export interface ItemRelationship {
  itemMasterCode: string;
  relationshipType: number;
  quantity?: number;
  unitOfMeasure?: number;
}

export enum ItemRelationshipType {
  Composition,
}

export enum Uom {
  pct = 7,
}

export interface ProcurementItemCategory {
  id: string;
  name: ResponseTranslation;
}
